import * as React from 'react';
import * as Yup from 'yup';
import { Formik, FormikProps, FormikValues, Field, FieldProps } from 'formik';

import { StyledForm, Box, Button, StyledFormSelect, StyledFormGroup, FieldRow } from '../../components';
import Span from '../../typography/Span';
import { formatFormValues } from '../../utils/helpers';
import { MutationFn } from 'react-apollo';
import NewFile from '../../components/NewFile';

const StakeholderDocumentValidation = Yup.object().shape({
  name: Yup.string(),
  billing: Yup.boolean(),
  status: Yup.mixed(),
});

interface Props {
  id?: string;
  mutation: MutationFn;
  error?: any;
  buttonText?: string;
  loading: boolean;
  initialValues: FormikValues;
  status?: 'NEW' | 'PAID' | 'ARCHIVED';
  billing?: boolean;
  document: { original: string; id: string };
  onCancel?: () => void;
}

type StakeholderDocumentValues = {
  name?: string;
  billing?: boolean;
  status?: { label: string; value: string };
  id?: string;
};

const FILE_STATUS = [
  { label: 'New', value: 'NEW' },
  { label: 'Paid', value: 'PAID' },
  { label: 'Archived', value: 'ARCHIVED' },
];

const StakeholderDocumentForm: React.FC<Props> = props => {
  const { billing, status, initialValues } = props;
  const [uploadedFile, setUploadedFile] = React.useState(null);
  const [fileName, setFileName] = React.useState(null);
  return (
    <Formik
      validationSchema={StakeholderDocumentValidation}
      enableReinitialize={true}
      initialValues={
        initialValues
          ? initialValues
          : {
              name: '',
              status: '',
              billing: '',
              id: '',
            }
      }
      onSubmit={(values: StakeholderDocumentValues) => {
        const formattedValues = formatFormValues(values);
        props.mutation({
          variables: uploadedFile
            ? {
                file: { create: uploadedFile },
                name: fileName,
                status,
                billing,
              }
            : formattedValues,
        });
      }}
      render={(formikProps: FormikProps<StakeholderDocumentValues>) => {
        return (
          <StyledForm>
            <Box width="100%" alignItems="flex-end" mb={1}>
              {props.initialValues ? (
                <React.Fragment>
                  <FieldRow width="100%">
                    <Field
                      name="name"
                      render={({ field }: FieldProps<StakeholderDocumentValues>) => (
                        <StyledFormGroup mr={4} {...field} field={field} form={formikProps} label="Name" />
                      )}
                    />
                    <Field
                      name="status"
                      render={({ field }: FieldProps<StakeholderDocumentValues>) => (
                        <StyledFormSelect
                          {...field}
                          field={field}
                          label="Status"
                          form={formikProps}
                          options={FILE_STATUS}
                        />
                      )}
                    />
                  </FieldRow>
                  <FieldRow width="100%">
                    <Field
                      name="id"
                      render={({ field }: FieldProps<StakeholderDocumentValues>) => (
                        <StyledFormGroup
                          {...field}
                          field={field}
                          form={formikProps}
                          label="Unique ID"
                          placeholder="Auto generated unique ID"
                          disabled={true}
                        />
                      )}
                    />
                  </FieldRow>
                  <Box flexDirection="row" mt={3} width="100%">
                    <Box width="100%" mr={4}>
                      <a href={initialValues.file.original} target="_blank">
                        <Button type="button" bg="coal" text="VIEW PDF" onClick={() => false} />
                      </a>
                    </Box>
                    <Button type="submit" text="Finish" isLoading={props.loading} />
                  </Box>
                </React.Fragment>
              ) : (
                <NewFile
                  // Save meta file name to state
                  onFileAdded={data => setFileName(data.meta.name)}
                  onUploadComplete={data => setUploadedFile(data)}
                />
              )}
              {uploadedFile && (
                <Box flexDirection="row" mt={4}>
                  <Button bg="coal" mr={3} type="button" text="Cancel" onClick={props.onCancel} />
                  <Button type="submit" text="Finish" isLoading={props.loading} />
                </Box>
              )}
            </Box>
            {props.error && (
              <Span width="100%" textAlign="center" color="error" mb={3}>
                {props.error.message.replace('GraphQL error:', '').trim()}
              </Span>
            )}
          </StyledForm>
        );
      }}
    />
  );
};

export default StakeholderDocumentForm;



// WEBPACK FOOTER //
// ./src/forms/stakeholders/StakeholderDocumentForm.tsx